import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Linkedin, Instagram, Facebook } from 'lucide-react';
import { siteInfo, contactInfo, footerLinks } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1a1a1a] text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-light mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              {siteInfo.name}
            </h3>
            <p className="text-white/60 text-sm leading-relaxed max-w-md mb-6">
              L'art de vivre à Songon. Un projet résidentiel d'exception 
              aux portes d'Abidjan, en Côte d'Ivoire.
            </p>
            
            {/* Social Links */}
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 border border-white/20 flex items-center justify-center hover:bg-white hover:text-[#1a1a1a] transition-all duration-300" data-testid="social-linkedin">
                <Linkedin className="w-4 h-4" />
              </a>
              <a href="#" className="w-10 h-10 border border-white/20 flex items-center justify-center hover:bg-white hover:text-[#1a1a1a] transition-all duration-300" data-testid="social-instagram">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" className="w-10 h-10 border border-white/20 flex items-center justify-center hover:bg-white hover:text-[#1a1a1a] transition-all duration-300" data-testid="social-facebook">
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs font-medium uppercase tracking-[0.2em] text-white/40 mb-6">
              Navigation
            </h4>
            <nav className="space-y-3">
              {footerLinks.navigation.map((link) => (
                <Link
                  key={link.label}
                  to={link.href}
                  className="block text-white/70 hover:text-white transition-colors duration-300 text-sm"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-medium uppercase tracking-[0.2em] text-white/40 mb-6">
              Contact
            </h4>
            <div className="space-y-3">
              <a href={`tel:${contactInfo.phone}`} className="flex items-center gap-3 text-white/70 hover:text-white transition-colors text-sm">
                <Phone className="w-4 h-4" />
                {contactInfo.phone}
              </a>
              <a href={`mailto:${contactInfo.email}`} className="flex items-center gap-3 text-white/70 hover:text-white transition-colors text-sm">
                <Mail className="w-4 h-4" />
                {contactInfo.email}
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/40 text-xs">
              © {currentYear} {siteInfo.name}. Tous droits réservés.
            </p>
            <p className="text-white/40 text-xs">
              Un projet <a href="https://onegreendev.com" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white">One Green Dev</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
